export default "__VITE_ASSET__Bf8EZAtL__"